import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAllSelectedStikisOnPage } from './stikisSlice'
import clsx from 'clsx'

import Box from '@mui/material/Box'

import Stiki from './Stiki'

import { selectStikisMovePosition } from '../ui/uiSlice'

const classes = {
  stikisMover: (position) => ({
    // #stikisMover {
    zIndex: 2,
    position: 'absolute',
    left: `${position.x}px`,
    top: `${position.y}px`,
    width: 0,
    height: 0,
    border: '0 solid black',
    backgroundColor: 'transparent',
    visibility: 'visible',
  }),
}

export default function StikisMover({ pageId }) {
  const selectedStikisSelector = useMemo(
    () => selectAllSelectedStikisOnPage(pageId),
    [pageId]
  )
  const selectedStikis = useSelector(selectedStikisSelector)
  const position = useSelector(selectStikisMovePosition)

  return (
    <Box id='stikisMover' sx={classes.stikisMover(position)}>
      {selectedStikis.map((stikiId) => {
        return <Stiki key={`stiki-${stikiId}`} stikiId={stikiId} />
      })}
    </Box>
  )
}
